import moment from "moment";

export const hasOwnProperty = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
// element class 만들기
export const unionClassName = (og, add) => {
    if (typeof og !== "string") return [];
    const arr = [og, ...add].filter(v => v !== null || v !== undefined || v !== "" || v !== false);
    return arr.join(" ");
};

export const oneDay = 24 * 1000 * 60 * 60;

export const isDateBetween = (now, targetDate) => {
    const postTime = new Date(moment(targetDate).format("YYYY/MM/DD")).getTime();
    if (now === postTime) return "오늘";
    if (now - oneDay === postTime) return "어제";
    if (now - oneDay * 2 === postTime) return "2일 전";

    return null;
};

// make FormData
export const dataEncoded = data => {
    const fd = new FormData();

    if (typeof data !== "object") {
        console.warn("It is not object type");
        return;
    }

    Object.keys(data).forEach(key => {
        const value = data[key];
        if (value !== null && value !== undefined && value !== "") {
            fd.append(key, value);
        }
    });

    return fd;
};

export const notAllowEmptyObject = data => {
    const result = {};

    Object.keys(data).forEach(key => {
        const value = data[key];
        if (value !== null && value !== undefined && value !== "") {
            result[key] = value;
        }
    });

    return result;
};

export const phoneHypen = phone => {
    if (/^(02)/.test(phone)) {
        // souel
        const exp = phone.length > 9 ? /(\d{2})(\d{4})(\d{4})/ : /(\d{2})(\d{3})(\d{4})/;
        return phone.replace(exp, "$1-$2-$3");
    }

    const exp = phone.length > 10 ? /(\d{3})(\d{4})(\d{4})/ : /(\d{2})(\d{3})(\d{4})/;
    return phone.replace(exp, "$1-$2-$3");
};

export const storageCheck = () => {
    const isAuto = localStorage.getItem("auto");
    const token = isAuto === "true" ? localStorage.getItem("token") : sessionStorage.getItem("token");

    return token;
};

export const storageClear = () => {
    localStorage.setItem("token", null);
    sessionStorage.setItem("token", null);
};

export const weekKO = ["일", "월", "화", "수", "목", "금", "토"];
export const weekFormat = date => date.replace(/(\|[0-6])/, n => weekKO[n[1]]);

export const nl2br = content => content.replace(/(\r\n|\n)/g, "<br/>");
export const sl2nbsp = content => content.replace(/\s/g, "&nbsp;");

// html text copy
export const copy = text => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
};

// scroll 계산기 , offsetHeight, scrollHeight, scrollTop, distance, callback
export const scrollCalculator = (offsetHeight, scrollHeight, scrollTop, distance, callback) => {
    const currentHeight = scrollTop + offsetHeight;
    const scrollLimitHeight = scrollHeight - distance;

    if (currentHeight > scrollLimitHeight) {
        callback && callback();
    }
};

export const expectStyleTag = content => {
    const _html = document.createElement("html");
    _html.innerHTML = content;

    const head = _html.children[0];
    _html.removeChild(head);

    const st = _html.getElementsByTagName("style");

    for (let i = 0; i < st.length; i++) {
        st[i].parentNode.removeChild(st[i]);
    }

    return _html.children[0].innerHTML;
};
